import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

const SelectMultipleInput = ({ type, name, value, getInputValue, removeInputValue, options, defaultSelect, soloVal }) => {

    const [selectMultiple, setSelectMultiple] = useState(defaultSelect !== "" ? defaultSelect.split(";") : [] )
    const [clickedValue, setClickedValue] = useState(0)

    useEffect(() => {
        setSelectMultiple(defaultSelect !== "" ? defaultSelect.split(";") : [])
    }, [defaultSelect])

    useEffect(() => {
        const _valArr = selectMultiple.join(';')
        const valArr = _valArr !== "" ? _valArr : ""
        getInputValue(name, valArr, clickedValue)
    }, [selectMultiple])

    const isSelected = (option) => {
      return(defaultSelect.includes(option.value.toString()))
    }

    const handleClick = (e, name, value) => {
        const el = e.target
        setClickedValue(value)

        if (Object.values(el.classList).find(cl => (cl === 'is-active'))) {
            console.log("here")
            console.log(selectMultiple)
            
            setSelectMultiple([...selectMultiple.filter(item => (item != value))])
            el.classList.remove('is-active')
        } else {
            console.log("there")
            if (value === soloVal) {
                setSelectMultiple([soloVal])
            } else {
                selectMultiple.push(value)
            setSelectMultiple([...selectMultiple])
            }

            el.classList.add('is-active')
            
        }
    }

    return (
        <>
            <div className={"option-list " + name}>
                    {
                    options.map(
                        option => (<div className={
                                isSelected(option) ? "option-multiple is-active" :
                                option.disabled === true ? "option-multiple disabled" :
                                "option-multiple"
                        } key={option.value}
                            onClick={(e) => handleClick(e,name, option.value)}
                        >  {option.label} </div>)
                    )
                }
            </div>
        </>
    )
 

};


SelectMultipleInput.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    error: PropTypes.array,
    checked: PropTypes.any,
    phoneCode: PropTypes.any,
    options: PropTypes.array,
    isNNumber: PropTypes.bool,
    isBCE: PropTypes.bool,
    getInputValue: PropTypes.func,
    max: PropTypes.number,


};

SelectMultipleInput.defaultProps = {
    type: "text",
    error: []
}

export default SelectMultipleInput
